import { ForwardedRef } from 'react';

import ContactField, { ContactFieldProps } from './ContactField';

function EmailField({
    ref = null,
    ...props
}: ContactFieldProps & { ref?: ForwardedRef<HTMLInputElement> | null }) {
    return <ContactField type="email" {...props} ref={ref} />;
}

export default EmailField;
